import { createRouter, createWebHashHistory } from 'vue-router';

import IndexVue from '@/views/layout/index.vue';
import BrankVue from '@/views/auxiliaryPage/brank.vue';
import SlidePPTVue from '@/views/home/slidePPT/slidePPT.vue';
import Product from '@/views/home/product/product.vue';
import Recycle from '@/views/home/recycle/recycle.vue';

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'index',
      component: IndexVue,
      redirect: '/slideppt',
      children: [
        {
          path: '/slideppt',
          name: 'slideppt',
          component: SlidePPTVue
        },
        {
          path: '/product',
          name: 'product',
          component: Product
        },
        {
          path: '/recycle',
          name: 'recycle',
          component: Recycle
        }
      ]
    },
    {
      path: '/brank',
      name: 'brank',
      component: BrankVue
    }
  ]
});

router.beforeEach((_to, _from, next) => {
  next();
});

export default router;
